import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import { GRADE_WISE_STRENGTH, RANK_WISE_STRENGTH } from 'features/supplier/utils';

const DEFAULT_ICON = <img width="20px" src={`${process.env.PUBLIC_URL}/icons/info.svg`} alt="sm" />;

const InfoPopUp = ({ gradeId, iconType, hoverTag = DEFAULT_ICON }) => {
	const gradeData = GRADE_WISE_STRENGTH[gradeId] || {};
	const rankData = RANK_WISE_STRENGTH[gradeId] || {};

	const renderStrength = () => (
		<Tooltip
			title={
				<span className="regular-14">
					{gradeData.map((item) => (
						<span className="brand-common-design mr-1 mb-1" key={item}>
							{item}
						</span>
					))}
				</span>
			}
			placement="top"
			arrow
		>
			<span>{hoverTag}</span>
		</Tooltip>
	);

	const renderSupplierRank = () => (
		<Tooltip
			title={
				<>
					<span className="regular-14 weight-500">{rankData}</span>
					<span className="regular-14 weight-300">
						{' '}
						(Based on On-time delivery, Compliance & Team feedback)
					</span>
				</>
			}
			placement="top"
			arrow
		>
			<span>{hoverTag}</span>
		</Tooltip>
	);

	return (
		<>
			{iconType === 'CERTIFICATE_STRENGTH' && renderStrength()}
			{iconType === 'GRADE' && renderSupplierRank()}
		</>
	);
};

export default InfoPopUp;
